/** Must match api/tebuto AuthService LOGIN_CODE_LENGTH / LOGIN_CODE_ALPHABET. */
export const CLIENT_LOGIN_CODE_LENGTH = 6

export const CLIENT_LOGIN_CODE_ALPHABET = '0123456789'

export const CLIENT_LOGIN_CODE_REGEX = /^\d{6}$/
